import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-category-deductibl-list-dialog',
  templateUrl: './category-deductibl-list-dialog.component.html',
  styleUrls: ['./category-deductibl-list-dialog.component.scss']
})
export class CategoryDeductiblListDialogComponent implements OnInit {
  isLoading = false;
  deductiblesList = [];
  constructor(private dialogRef: MatDialogRef<CategoryDeductiblListDialogComponent>,@Inject(MAT_DIALOG_DATA) dialoData?: any) {
    if(dialoData && dialoData.length) {
      dialoData.map((data:any)=>{
        if(data.deductibles && data.deductibles.length){
          data.deductibles.map((value:any)=>{
            if(!value.category || !value.hasOwnProperty('category')){
              value.category = data.description;
            }

            this.deductiblesList.push(value);
          })
        }
      })
    }
   }

  ngOnInit() {
  }


  onClose() {
    this.dialogRef.close();
  }

  showBorder(index:any,length:any) {
    const len = length - 1;
    return index == len?true:false;
  }

}
